/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CompanyDailyNavConfigCompWrite = {
  comp_type: CompanyDailyNavConfigCompWrite.comp_type;
  cap_iq_id: string;
  ticker_symbol: string;
  company_name: string;
  alexandria_id?: string | null;
};
export namespace CompanyDailyNavConfigCompWrite {
  export enum comp_type {
    PUBLIC_COMP = 'public_comp',
    ETF = 'etf',
  }
}

